// helpers/constants
import {
  ORGANIZE_BY_TRUCK,
  ORGANIZE_BY_DRIVER,
} from '../../constants';
//////////////////////////////////////////////////

export const STORE_NAME = 'driverCardsV2';

export const REQUEST_LIMIT = 200;
export const MIN_VISIBLE_DAYS = 1;
export const GROUP_ROW_HEIGHT = 42;
export const NORMAL_ROW_HEIGHT = 128;
export const EDIT_LANE_HEIGHT = 90;
export const EDIT_ROW_MIN_HEIGHT = 190;
export const INITIAL_VISIBLE_DAYS = 7;
export const MAX_VISIBLE_DAYS = 7;
export const EDIT_HISTORY_LIMIT = 100;
export const RESOURCE_RAIL_WIDTH = 400;
export const TIMELINE_SNAP_MS = 15 * 60 * 1000;
export const TIMELINE_PRECISION_FACTOR = 10;
export const TIMELINE_PRECISION_SNAP_MS = 60 * 1000;
export const MIN_LOAD_DURATION_MS = TIMELINE_SNAP_MS;
export const EDIT_ROW_VERTICAL_PADDING = 48;
export const MAXIMUM_CASCADE_DEPTH = 4;
export const NORMAL_CASCADE_OFFSET = 11;
export const DEFAULT_SEARCH_RADIUS = 100;
export const DEFAULT_ADVANCED_SEARCH_RADIUS = 50;
export const TIMELINE_SCROLLBAR_HEIGHT = 14;
export const TIMELINE_RIGHT_GUTTER_WIDTH = 2;

export const RESOURCE_MODE_TRUCK = ORGANIZE_BY_TRUCK;
export const RESOURCE_MODE_DRIVER = ORGANIZE_BY_DRIVER;

export const RESOURCE_GROUP_KIND = 'GROUP';
export const TIMELINE_EVENT_KIND_DELIVERY = 'DELIVERY';
export const TIMELINE_EVENT_SCHEDULED_DATE_FIELD = 'scheduledDate';
export const LEGACY_TIMELINE_EVENTS_FIELD = 'telEvents';

export const EDIT_COMMAND_MOVE_LOAD = 'MOVE_LOAD';
export const EDIT_COMMAND_MOVE_EVENT = 'MOVE_EVENT';
export const EDIT_COMMAND_INSERT_LOAD = 'INSERT_LOAD';
export const EDIT_COMMAND_REMOVE_LOAD = 'REMOVE_LOAD';
export const EDIT_COMMAND_EDIT_LOAD_RATE = 'EDIT_LOAD_RATE';
export const EDIT_COMMAND_RESIZE_LOAD_END = 'RESIZE_LOAD_END';
export const EDIT_COMMAND_RESIZE_LOAD_START = 'RESIZE_LOAD_START';
export const EDIT_COMMAND_EDIT_STOP_DETAILS = 'EDIT_STOP_DETAILS';
export const EDIT_COMMAND_HYDRATE_SERVER_EVENTS = 'HYDRATE_SERVER_EVENTS';
export const EDIT_COMMAND_RECONCILE_SERVER_LOAD = 'RECONCILE_SERVER_LOAD';
export const EDIT_COMMAND_EDIT_STOP_APPOINTMENTS = 'EDIT_STOP_APPOINTMENTS';
